import { ResetPassword } from "./reset-password";

export default function ResetPasswordPage({ mode = 'reset' }: { mode?: 'reset' | 'invite' }) {
  return <ResetPassword mode={mode} />;
}